import {Scope} from "./profile.interface";

export interface User {
  sub: string
  idpID: string
  username: string,
  email: string,
  given_name: string,
  family_name: string,
  scope: Scope
  user_scope: Scope
}
